







































import {addEmployee,queryEmployeeById,updateEmployee,ResetEmployee} from '@/api/employee'
import router from '@/router';
export default {
  data() {
    return {
      optType: '',//当前操作的类型，新增或者修改
      ruleForm: {
        name: '',
        username: '',
        sex: '1',
        phone: '',
        idNumber: ''
      },
      rules: {
        name: [
            { required: true, message: '请输入员工姓名', trigger: 'blur' }
        ],
        username: [
            { required: true, message: '请输入员工账号', trigger: 'blur' }
        ],
        phone: [
          { required: true, trigger: 'blur',validator: (rule,value,callback) => {
              if(value === '' || (!/^1(3|4|5|6|7|8)\d{9}$/.test(value))){
                callback(new Error('请输入正确的手机号！'))
              }else{
                callback()
              }
            } 
          }
        ],
        idNumber: [
          { required: true, trigger: 'blur',validator: (rule,value,callback) => {
              if(value === '' || (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(X|x)$)/.test(value))){
                callback(new Error('请输入正确的身份证号！'))
              }else{
                callback()
              }
            } 
          }
        ]
      }
    }
  },
  created() {
    //获取路由参数（id），如果有则为修改操作，否则为新增操作
    this.optType = this.$route.query.id ? 'update' : 'add'
    if(this.optType === 'update') {
      //修改操作，需要根据id查询员工信息用于页面回显
      queryEmployeeById(this.$route.query.id).then(res => {
        if(res.data.code === 1){
          this.ruleForm = res.data.data
        }
      })
    }
  },
  methods: {
    submitForm(formName,isContinue){
      //进行表单校验
      this.$refs[formName].validate((valid) => {
        if(valid) {
          //表单校验通过，发起Ajax请求，将数据提交到后端
          if(this.optType === 'add'){//新增操作
            addEmployee(this.ruleForm).then((res) => {
                if(res.data.code === 1){
                  this.$message.success('员工添加成功！')
                  if(isContinue){
                  this.ruleForm = {
                      name: '',
                      username: '',
                      sex: '1',
                      phone: '',
                      idNumber: ''
                    }
                  }else {
                    this.$router.push('/employee')
                  }
                }else {
                  this.$message.error(res.data.msg)
                }
              })
          }else{//修改操作
            updateEmployee(this.ruleForm).then(res => {
              if(res.data.code === 1){
                this.$message.success('员工信息修改成功！')
                this.$router.push('/employee')
              }
            })
          }
        }
      })
    },
    resetPwd(){
      ResetEmployee(this.$route.query.id).then(res =>{
        if(res.data.code === 1){
          this.$message.success('员工密码重置成功！')
        }
      })
    }
  }
}
